/* Publish by EComposer at 2026-10-02 09:15:36*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-ax4mcxkzk8"]=  window.__ectimmers["ecom-ax4mcxkzk8"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),o=t.querySelector(".text-content.ecom-html");!o||(e&&e.addEventListener("click",()=>{o.classList.remove("ecom-text--is-mark"),o.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{o.classList.add("ecom-text--is-mark"),o.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-ax4mcxkzk8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ax4mcxkzk8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-eri29sy0m79').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-eri29sy0m79', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-k33bubdzr9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-k33bubdzr9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0n1nxzg2s8e').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0n1nxzg2s8e', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9uhplaxyub').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9uhplaxyub', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-em06yysrh4c').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-em06yysrh4c', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hol1bcs5h2').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hol1bcs5h2', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-e4hqo6span').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-e4hqo6span', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5aeeylxixxv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5aeeylxixxv', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-f9akung35im').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-f9akung35im', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-10e1m5zrdy7a').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-10e1m5zrdy7a', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-al0h55i2d3q').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-al0h55i2d3q', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-i5gqh45stmc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-i5gqh45stmc', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-p5aaxtumty"]=  window.__ectimmers["ecom-p5aaxtumty"] || {};
if(!this.$el)return!1;const t=this.$el;this.settings.animation&&function(i){if(!t)return;const o=t.querySelector(".ecom__element--button");if(!o)return;let n=parseInt(i.settings.animation_loop_time)*1e3||6e3,s=1e3;window.__ectimmers["ecom-p5aaxtumty"]["rft3uwfae"] = setInterval(function(){o.classList.add("animated"),setTimeout(function(){o.classList.remove("animated")},s)},n)}(this);var e=t.querySelector(".ecom__element--button");this.isLive&&e&&e.dataset.ecTrackingId&&e.addEventListener("click",function(i){if(window.Shopify&&window.Shopify.analytics){i.preventDefault();let o=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const n=Object.assign({button_id:e.id,tracking_id:e.dataset.ecTrackingId},o);try{Shopify.analytics.publish("ec_custom_events",n)}catch(a){console.error("[EC Tracking] Error publishing analytics event:",a)}const s=e.getAttribute("href"),r=e.getAttribute("target");s&&s!=="#"&&s!=="javascript:void(0)"&&(r==="_blank"?window.open(s,"_blank"):setTimeout(function(){window.location.href=s},300))}},{once:!0}),this.isLive&&e&&e.dataset.eventTrackingFb&&e.addEventListener("click",function(i){window.fbq&&window.fbq("track",`${e.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-p5aaxtumty').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-p5aaxtumty', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-q2k89k2nvks').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-q2k89k2nvks', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7g284xnxrga').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7g284xnxrga', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xkzmacuo4tq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xkzmacuo4tq', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qmjt5i6q7v').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qmjt5i6q7v', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5cvg32h71j').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5cvg32h71j', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pfrudq1geen').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pfrudq1geen', settings: {"animation":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-y47lca71c1"]=  window.__ectimmers["ecom-y47lca71c1"] || {};
if(!this.$el||!window.EComModal)return;const t=this.isLive;let e=this.$el.querySelectorAll("[ecom-modal]");e.length&&t&&new window.EComModal(e,{gallery:!0,cssClass:["ecom-container-lightbox-"+this.id]})

                    });
                    
                        document.querySelectorAll('.ecom-y47lca71c1').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-y47lca71c1', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-u7fby9wxgt8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-u7fby9wxgt8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-w3ihnxudlc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-w3ihnxudlc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-meuqid9vfuq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-meuqid9vfuq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1by2iu4jldl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1by2iu4jldl', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wawr4o75v9b').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wawr4o75v9b', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rgflz1y66zb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rgflz1y66zb', settings: {},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}